(() => {
  if (window.gridoneBrandChoiceInstalled) return;
  window.gridoneBrandChoiceInstalled = true;
  const updateImage = (card, url, alt, exact = true) => {
    const image = card.querySelector('[data-guc-photo]');
    if (image && url) {
      if (image.getAttribute('src') !== url) {
        image.loading = 'eager';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
      }
      image.alt = alt || card.dataset.title || '';
    }
    const note = card.querySelector('[data-guc-photo-note]');
    if (note) note.hidden = exact;
  };
  const init = () => {
    document.querySelectorAll('[data-guc-choice]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const select = card.querySelector('[data-guc-model]');
      if (select) {
        const update = () => {
          const option = select.selectedOptions[0];
          card.querySelector('[data-guc-price]').textContent = option.dataset.price;
          card.querySelector('[data-guc-request]').href = option.dataset.href;
          card.querySelector('[data-guc-tax]').hidden = option.dataset.tax !== 'true';
          updateImage(card, option.dataset.image, option.dataset.imageAlt, option.dataset.exactImage === 'true');
          const benefit = card.querySelector('[data-guc-benefit]');
          if (benefit) benefit.textContent = option.dataset.benefit || card.dataset.fallback || '';
          ['contents', 'check'].forEach(key => {
            const target = card.querySelector('[data-guc-' + key + ']');
            const row = card.querySelector('[data-guc-' + key + '-row]');
            if (target) target.textContent = option.dataset[key] || '';
            if (row) row.hidden = !option.dataset[key];
          });
          const includes = card.querySelector('[data-guc-includes]');
          if (includes) includes.hidden = !option.dataset.contents && !option.dataset.check;
        };
        select.addEventListener('change', update);
        update();
      }
      const data = card.querySelector('[data-guc-variants]');
      if (data) {
        const variants = JSON.parse(data.textContent);
        const options = [...card.querySelectorAll('[data-guc-option]')];
        const link = card.querySelector('[data-guc-request]');
        const update = () => {
          const variant = variants.find(v => v.options.every((value, i) => options[i] && options[i].value === value));
          if (!variant) return;
          card.querySelector('[data-guc-price]').textContent = variant.price;
          const url = new URL(link.href, location.href);
          url.searchParams.set('produkt', [card.dataset.title, variant.title === 'Default Title' ? '' : variant.title].filter(Boolean).join(', '));
          link.href = url.href;
          updateImage(card, variant.image, variant.alt);
        };
        options.forEach(option => option.addEventListener('change', update));
        update();
      }
    });
    document.querySelectorAll('.goa-inquiry-form select').forEach(select => {
      if (select.dataset.priceReady) return;
      select.dataset.priceReady = 'true';
      const price = select.closest('.goa-card')?.querySelector('[data-goa-price]');
      const update = () => {
        const amount = select.selectedOptions[0]?.dataset.goaPrice;
        if (price && amount) price.textContent = amount;
      };
      select.addEventListener('change', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
